import {
	Checkbox,
	IconButton,
	Menu,
	MenuItem,
	TableCell,
	TableRow,
	Typography
} from '@mui/material';
import { MoreHoriz } from '@mui/icons-material';
import React from 'react';

import { useMenu } from 'hooks';
import { MONTHS } from 'lib/constants';
import { ellipsis, properCase } from 'lib/utils';

const LotteryItem = ({
	lottery,
	isSelectable,
	selectedIds = [],
	handleSelect,
	handleClick,
	handleSelectWinnerClick,
	handleEditClick,
	handleDeleteClick,
	...props
}) => {
	const { open, anchorEl, handleToggleMenu, handleClose } = useMenu();

	const renderMenu = () => (
		<Menu open={open} onClose={handleClose} anchorEl={anchorEl}>
			{!lottery?.winner?.id && (
				<MenuItem onClick={(e) => handleSelectWinnerClick(lottery, e)}>
					Select Winner
				</MenuItem>
			)}
			<MenuItem onClick={(e) => handleEditClick(lottery, e)}>Edit</MenuItem>
			<MenuItem onClick={(e) => handleDeleteClick(lottery, e)}>Delete</MenuItem>
		</Menu>
	);

	const isSelected = selectedIds.includes(lottery.id);

	return (
		<TableRow
			hover
			onClick={() => handleClick(lottery)}
			sx={{ cursor: 'pointer' }}
		>
			{isSelectable && (
				<TableCell>
					<Checkbox
						checked={isSelected ? true : false}
						onChange={() => handleSelect(lottery)}
						name="lottery"
						color="primary"
					/>
				</TableCell>
			)}
			<TableCell>
				<Typography variant="primary.text">
					{MONTHS[lottery.month - 1]}
				</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="primary.text">{lottery.year}</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="primary.text">
					{lottery.points_required}
				</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="primary.text">
					{ellipsis(lottery.prize_description, 50)}
				</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="primary.text">
					{lottery?.winner?.first_name} {lottery?.winner?.last_name}
				</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="primary.text">
					{properCase(lottery.status)}
				</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="primary.text">{lottery.created_at}</Typography>
			</TableCell>
			<TableCell align="right">
				<IconButton
					onClick={(e) => {
						e.stopPropagation();
						handleToggleMenu(e);
					}}
				>
					<MoreHoriz />
				</IconButton>
				{renderMenu()}
			</TableCell>
		</TableRow>
	);
};

export default LotteryItem;
